/**
 * Ingredient products — load Prestige main-collection grid (Section Rendering API)
 * with eros.actives filter. Distinguishes true empty vs fetch/section failure (retry).
 * On filter empty/error: retry without filter and show an unfiltered note (ADR-163 parity).
 */
(function () {
  var root = document.querySelector('[data-eros-ingredient-products]');
  if (!root) return;

  var host = root.querySelector('[data-eros-ingredient-products-host]');
  var loading = root.querySelector('[data-eros-ingredient-products-loading]');
  var empty = root.querySelector('[data-eros-ingredient-products-empty]');
  var errorEl = root.querySelector('[data-eros-ingredient-products-error]');
  var errorMsg = root.querySelector('[data-eros-ingredient-products-error-msg]');
  var errorDetail = root.querySelector('[data-eros-ingredient-products-error-detail]');
  var retryBtn = root.querySelector('[data-eros-ingredient-products-retry]');
  var noteEl = root.querySelector('[data-eros-ingredient-products-note]');
  if (!host) return;

  var collectionHandle = root.getAttribute('data-collection-handle') || 'all-products';
  var ingredientGid = root.getAttribute('data-ingredient-gid') || '';
  var filterParam = root.getAttribute('data-filter-param') || 'filter.p.m.eros.actives';
  var sectionCandidates = (root.getAttribute('data-section-ids') || 'main')
    .split(',')
    .map(function (s) {
      return s.trim();
    })
    .filter(Boolean);
  if (!sectionCandidates.length) sectionCandidates = ['main'];

  var strings = {
    error: root.getAttribute('data-i18n-error') || "Couldn't load products",
    network: root.getAttribute('data-i18n-error-network') || 'Network error',
    http: root.getAttribute('data-i18n-error-http') || 'Server returned {{ status }}',
    section: root.getAttribute('data-i18n-error-section') || 'Collection section missing from response',
    emptyFilter: root.getAttribute('data-i18n-error-empty-filter') || 'Filter returned no products',
    unfilteredNote:
      root.getAttribute('data-i18n-unfiltered-note') ||
      'Showing catalog results without the ingredient filter.',
  };

  function interpolate(template, vars) {
    return String(template || '').replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      return vars && vars[key] != null ? String(vars[key]) : '';
    });
  }

  function setHidden(el, hidden) {
    if (!el) return;
    el.hidden = !!hidden;
  }

  function showLoading() {
    host.replaceChildren();
    setHidden(loading, false);
    setHidden(empty, true);
    setHidden(errorEl, true);
    setHidden(noteEl, true);
  }

  function showEmpty() {
    host.replaceChildren();
    setHidden(loading, true);
    setHidden(errorEl, true);
    setHidden(noteEl, true);
    setHidden(empty, false);
  }

  function showError(reason) {
    host.replaceChildren();
    setHidden(loading, true);
    setHidden(empty, true);
    setHidden(noteEl, true);
    if (errorMsg) errorMsg.textContent = strings.error;
    if (errorDetail) {
      errorDetail.textContent = reason || '';
      errorDetail.hidden = !reason;
    }
    setHidden(errorEl, false);
  }

  function showSuccess(wrap, opts) {
    opts = opts || {};
    setHidden(loading, true);
    setHidden(empty, true);
    setHidden(errorEl, true);
    if (noteEl) {
      if (opts.unfiltered) {
        noteEl.textContent = strings.unfilteredNote;
        setHidden(noteEl, false);
      } else {
        setHidden(noteEl, true);
      }
    }
    host.replaceChildren(wrap);
  }

  function routesRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function buildFetchUrl(sectionId, useFilter) {
    var url =
      routesRoot() +
      'collections/' +
      encodeURIComponent(collectionHandle) +
      '?section_id=' +
      encodeURIComponent(sectionId);
    if (useFilter && ingredientGid) {
      url +=
        '&' +
        filterParam +
        '=' +
        encodeURIComponent(ingredientGid);
    }
    return url;
  }

  function findSectionEl(doc) {
    return (
      doc.querySelector('#shopify-section-main') ||
      doc.querySelector('.shopify-section--main-collection') ||
      doc.querySelector('#shopify-section-main-collection') ||
      doc.querySelector('[id^="shopify-section-"]')
    );
  }

  function extractCards(sectionEl) {
    var main = sectionEl.querySelector('.collection__main');
    var cardsRoot = main || sectionEl;
    return {
      main: main,
      cards: cardsRoot.querySelectorAll('product-card, .product-card'),
    };
  }

  function buildWrap(sectionEl, main) {
    var styleEl = sectionEl.querySelector('style');
    var wrap = document.createElement('div');
    wrap.className = 'eros-ingredient-page__collection color-scheme color-scheme--scheme-1';
    var container = document.createElement('div');
    container.className = 'container';
    if (styleEl) wrap.appendChild(styleEl.cloneNode(true));
    container.appendChild((main || sectionEl).cloneNode(true));
    wrap.appendChild(container);
    return wrap;
  }

  function fetchSection(sectionId, useFilter) {
    return fetch(buildFetchUrl(sectionId, useFilter)).then(function (response) {
      if (!response.ok) {
        var err = new Error(
          interpolate(strings.http, { status: response.status }),
        );
        err.code = 'http';
        err.status = response.status;
        throw err;
      }
      return response.text().then(function (html) {
        return { html: html, sectionId: sectionId, useFilter: useFilter };
      });
    });
  }

  function trySections(useFilter, index) {
    index = index || 0;
    if (index >= sectionCandidates.length) {
      var err = new Error(strings.section);
      err.code = 'section';
      return Promise.reject(err);
    }
    return fetchSection(sectionCandidates[index], useFilter)
      .then(function (payload) {
        var doc = new DOMParser().parseFromString(payload.html, 'text/html');
        var sectionEl = findSectionEl(doc);
        if (!sectionEl) {
          return trySections(useFilter, index + 1);
        }
        var extracted = extractCards(sectionEl);
        return {
          sectionEl: sectionEl,
          main: extracted.main,
          cards: extracted.cards,
          sectionId: payload.sectionId,
          useFilter: useFilter,
        };
      })
      .catch(function (err) {
        if (err && err.code === 'http' && index + 1 < sectionCandidates.length) {
          return trySections(useFilter, index + 1);
        }
        throw err;
      });
  }

  function load() {
    if (!ingredientGid) {
      showEmpty();
      return;
    }

    showLoading();

    trySections(true, 0)
      .then(function (result) {
        if (result.cards && result.cards.length) {
          showSuccess(buildWrap(result.sectionEl, result.main), { unfiltered: false });
          return null;
        }
        // Filter empty → retry without filter (do not silent-fail).
        return trySections(false, 0).then(function (fallback) {
          if (fallback.cards && fallback.cards.length) {
            showSuccess(buildWrap(fallback.sectionEl, fallback.main), {
              unfiltered: true,
            });
            return;
          }
          showEmpty();
        });
      })
      .catch(function (err) {
        var reason =
          (err && err.message) || strings.network;
        // Prefer unfiltered recovery over hard error when filter path failed.
        trySections(false, 0)
          .then(function (fallback) {
            if (fallback.cards && fallback.cards.length) {
              showSuccess(buildWrap(fallback.sectionEl, fallback.main), {
                unfiltered: true,
              });
              return;
            }
            showError(reason || strings.emptyFilter);
          })
          .catch(function (err2) {
            showError(
              reason +
                (err2 && err2.message && err2.message !== reason
                  ? ' · ' + err2.message
                  : ''),
            );
          });
      });
  }

  if (retryBtn) {
    retryBtn.addEventListener('click', function () {
      load();
    });
  }

  load();
})();
